import React, { useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { BsPinMapFill, BsPhone, BsEnvelope } from "react-icons/bs";
import Header from "../components/Layout/Header";
import { LanguageContext } from "../context/LanguageContext";
import "./KrushiMahostavEvent.css";

// Import images/videos
import Event1 from "../assets/JKM26.jpg";
import Event2 from "../assets/JKM marathi.png";
import Event3 from "../assets/jkm.webp";
import EventVideo from "../assets/krushi-mahostav.mp4";

const translations = {
  en: {
    header: "Krushi Mahotsav - Global Agriculture Festival",
    aboutTitle: "About Krushi Mahotsav",
    aboutDesc: `Krushi Mahotsav is an international agricultural festival organized in Nashik under the Shri Swami Samarth Seva Spiritual Development Path (Dindori). It brings together farmers, agricultural experts, industries, social organizations, and students to provide knowledge, technology, and market linkages. With a successful tradition over the past 15+ years, millions of farmers participate, multilingual dialogues are conducted, and community-oriented initiatives make this festival an influential platform for the agricultural sector.`,
    goalTitle: "Our Goal",
    goalDesc: `To empower agriculture through knowledge, technology, and community engagement; to promote sustainable and eco-friendly practices; and to increase farmers' income and stability by connecting them directly to markets. Focused guidance is provided on advanced agriculture, modern technology, traditional sustainable, spiritual, organic, and natural farming.`,
    featuresTitle: "Features",
    features: [
      "National Agricultural Exhibition",
      "India & Agricultural Culture Showcase",
      "Rare Forest Medicinal Plants & Indigenous Seed Display",
      "Farmer Family Welfare: Bride-Groom Meet & Mass Marriage Events, Employment Fair"
    ],
    whatWeDoTitle: "What We Do",
    whatWeDoDesc: `We organize expert sessions, workshops, and hands-on demonstrations covering all aspects from modern to natural farming. Through A2B, B2B, and B2C sections, we connect farmers, industries, and consumers directly, assisting with distributor appointments and sales. Exhibitions include agricultural tools, irrigation, soil-water testing, livestock, nurseries, organic inputs, processing industries, and agro-tourism.`,
    impactTitle: "Impact",
    impactDesc: `In 2025, 503 exhibitors and 1,13,000+ visitors attended; 84,285 pre-registered online visitors. Equipped infrastructure with multilingual volunteers, large parking, and extensive exhibition area. Over 15+ years of continuous tradition, reaching millions of farmers.`,
    locationTitle: "Location",
    locationDesc: `Venue: Yuva Mahotsav Ground, Bidi Kamgar Colony, Hanuman Nagar, Nashik, Maharashtra 422006.`,
    contactTitle: "Contact",
    contactDesc: `Shri Swami Samarth Seva & Spiritual Development Center Dindori, Taluka: Dindori, District: Nashik
Pincode: 422202
Email: krushimahotsav@gmail.com | Phone: +91 9423568419`,
    home: "Home",
  },
  mr: {
    header: "जागतिक कृषी महोत्सव",
    aboutTitle: "जागतिक कृषी महोत्सव बद्दल",
    aboutDesc: `उत्तम शेती, मध्यम व्यापार, कनिष्ठ नौकरी – परम पूज्य गुरुमाउली
जागतिक कृषी महोत्सव हा श्री स्वामी समर्थ सेवा अध्यात्मिक विकास मार्ग (दिंडोरी प्रणीत) मार्ग आयोजित नाशिकमधील आंतरराष्ट्रीय स्वरूपाचा कृषी महोत्सव आहे जो शेतकरी, कृषीतज्ज्ञ, उद्योग, सामाजिक संस्था आणि विद्यार्थी यांना एकत्र आणून ज्ञान, तंत्रज्ञान आणि बाजारपेठ दुवे उपलब्ध करून देतो. गेल्या 15+ वर्षांतील यशस्वी परंपरेत लाखो शेतकऱ्यांचा सहभाग, विविध प्रादेशिक भाषांमधील संवाद आणि समाजाभिमुख उपक्रमांमुळे हा महोत्सव कृषिक्षेत्रासाठी प्रभावी व्यासपीठ ठरला आहे.`,
    goalTitle: "आमचे ध्येय",
    goalDesc: `शेतीला ज्ञान, तंत्रज्ञान आणि समुदाय-संलग्नतेद्वारे सक्षम करणे, शाश्वत आणि पर्यावरणपूरक पद्धतींचा प्रसार करणे, तसेच शेतकऱ्यांना थेट बाजाराशी जोडून त्यांच्या उत्पन्नात व स्थैर्यात वाढ घडवणे. प्रगत शेती, आधुनिक तंत्रज्ञान, पारंपरिक शाश्वत, आध्यात्मिक, सेंद्रिय आणि नैसर्गिक शेती यांवर भर देत व्यापक मार्गदर्शन, प्रबोधन करणे.`,
    featuresTitle: "वैशिष्ट्ये",
    features: [
      "राष्ट्रीय कृषी प्रदर्शन",
      "भारत व कृषी संस्कृति दर्शन",
      "दुर्मिळ वन औषधि व देशी बिज प्रदर्शन",
      "शेतकरी कुटुंब कल्याण अंतर्गत वधू-वर परिचय मेळावा व सामुहिक विवाह मेळावा रोजगार मेळावा"
    ],
    whatWeDoTitle: "आम्ही काय करतो",
    whatWeDoDesc: `तज्ज्ञ सत्रे, कार्यशाळा आणि प्रत्यक्ष प्रात्यक्षिके आयोजित करून आधुनिक ते नैसर्गिक शेतीपर्यंत सर्व अंगांचा परिचय करतो.
A2B, B2B, B2C या विशेष विभागांद्वारे शेतकरी, उद्योग आणि ग्राहकांना थेट जोडतो, वितरक नियुक्ती आणि विक्रीसाठी मदत करतो.
कृषी अवजारे, सिंचन, माती-पाणी चाचणी, पशुधन, नर्सरी, सेंद्रिय इनपुट्स, प्रक्रिया उद्योग आणि शेतीपर्यटन अशा विभागांचे प्रदर्शन सादर करतो.`,
    impactTitle: "प्रभाव",
    impactDesc: `2025 मध्ये 503 प्रदर्शक आणि 1,13,000+ अभ्यागतांची नोंद; 84,285 पूर्व-नोंदणीकृत ऑनलाइन अभ्यागत.
बहुभाषिक स्वयंसेवक, मोठी पार्किंग व विस्तृत प्रदर्शन क्षेत्रासह सुसज्ज पायाभूत सुविधा.
15+ वर्षांची सातत्यपूर्ण परंपरा आणि लाखो शेतकऱ्यांपर्यंत पोहोच.`,
    locationTitle: "ठिकाण",
    locationDesc: `स्थळ: युवा महोत्सव मैदान, बिडी कामगार कॉलनी, हनुमान नगर, नाशिक, महाराष्ट्र 422006.`,
    contactTitle: "संपर्क",
    contactDesc: `श्री स्वामी समर्थ सेवा व आध्यात्मिक विकास केंद्र दिंडोरी,  तालुका: दिंडोरी जिल्हा: नाशिक
पिन कोड नं.-422202 ईमेल: krushimahotsav@gmail.com | फोन: +91 9423568419`,
    home: "मुख्यपृष्ठ",
  }
};

export default function KrushiMahostavEvent() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang];

  const images = [Event1, Event2, Event3];
  const videoRef = useRef(null);
  const [playVideo, setPlayVideo] = useState(false);

  const handleVideoClick = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.muted = false;
      videoRef.current.play();
      setPlayVideo(true);
    } else {
      videoRef.current.pause();
      setPlayVideo(false);
    }
  };

  return (
    <div className="krushi-page">
      {/* Header + Breadcrumb */}
      <div className="header-styled">
        <Header />
        <header className="krushi-header">
          <div className="header-center">
            <div className="breadcrumb">
            <Link to="/">{t.home}</Link>  &gt;  <span>{t.header}</span>
            </div>
            <h1>{t.header}</h1>
          </div>
        </header>
      </div>

      {/* Hero Video */}
      <section className="krushi-video-card">
        <video
          ref={videoRef}
          src={EventVideo}
          poster={images[0]}
          className="krushi-video"
          playsInline
          controls
          muted
        />
        <div className="video-overlay" onClick={handleVideoClick}>
          <span>▶ Watch Video</span>
        </div>
      </section>

      {/* Main Info */}
      <main className="krushi-main">
        <div className="krushi-info-left">
          <h2>{t.aboutTitle}</h2>
          <p>{t.aboutDesc}</p>

          <h3>{t.goalTitle}</h3>
          <p>{t.goalDesc}</p>

          <h3>{t.featuresTitle}</h3>
          <ul className="specialties">
            {t.features.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>

          <h3>{t.whatWeDoTitle}</h3>
          <p>{t.whatWeDoDesc}</p>

          <h3>{t.impactTitle}</h3>
          <p>{t.impactDesc}</p>

          <h3>{t.locationTitle}</h3>
          <p>{t.locationDesc}</p>

          <h3>{t.contactTitle}</h3>
          <p>{t.contactDesc}</p>
        </div>

        {/* Gallery Section */}
        <section className="krushi-gallery">
          <h2>Gallery</h2>
          <div className="gallery-grid">
            {images.map((img, i) => (
              <div key={i} className="gallery-item">
                <img src={img} alt={`Event ${i + 1}`} />
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
